import DashboardContainer from 'Components/Dashboard/DashboardContainer';
import { useEffect, useState } from 'react';
import { QUERY_PARAMS } from 'Routes/profileRoutes';
import { Auth0Service } from 'Services/ServiceFactory';
import { getIsLoggedIn } from 'Utils/auth/authUtils';
import { i18nextInit } from 'Utils/localization/i18next';
import { getQueryStringValue, isValidIKEAUrl } from 'Utils/url/urlUtils';
import '../styles/common.scss';

const mode = getQueryStringValue(
  window.location.search,
  QUERY_PARAMS.TRANSLATE
);

i18nextInit(mode);

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(null);

  useEffect(() => {
    getIsLoggedIn().then(loggedIn => {
      if (!loggedIn) {
        const from = window.location.href;
        Auth0Service.login(isValidIKEAUrl(from) ? from : undefined);
      } else {
        setIsLoggedIn(true);
      }
    });
  }, []);

  if (!isLoggedIn) return null;
  return <DashboardContainer />;
};

export default App;
